import axios from '@/plugins/axios.js'

export function get() {
    return axios.get("mp/config");
}

export function save(params) {
    return axios.post("mp/config", params);
}

export function refreshAccessToken(){
    return axios.get("mp/config/refreshAccessToken");
}